// ============================================================
// appConfig.ts — Caché en memoria de la configuración
// institucional cargada desde el backend (/api/v1/institucion).
// La función cargarConfig() se mantiene como stub vacío para
// compatibilidad con tests existentes.
// ============================================================

import { InstitucionData } from 'types/institucion.types';

export interface ConfigRol {
  idRol:  number;
  nombre: string;
  label:  string;
}

export interface AppConfig {
  institucionNombre: string;
  correodominio:     string;
  correoSoporte:     string;
  roles:             ConfigRol[];
  // Campos extendidos desde el backend
  codigoModular?:    string;
  ugel?:             string;
  dre?:              string;
  directorNombre?:   string;
  direccion?:        string;
  telefono?:         string;
  email?:            string;
  turno?:            string;
}

const DEFAULTS: AppConfig = {
  institucionNombre: 'Institución Educativa',
  correodominio:     '@institucion.edu.pe',
  correoSoporte:     'soporte@institucion.edu.pe',
  roles:             [],
};

let cache: AppConfig = { ...DEFAULTS };

/** Puebla el caché con los datos traídos por institucionService. */
export function setInstitucionData(data: InstitucionData): void {
  cache = {
    ...cache,
    institucionNombre: data.nombre         || DEFAULTS.institucionNombre,
    correodominio:     data.correodominio  || DEFAULTS.correodominio,
    correoSoporte:     data.correoSoporte  || DEFAULTS.correoSoporte,
    codigoModular:     data.codigoModular  || undefined,
    ugel:              data.ugel           || undefined,
    dre:               data.dre            || undefined,
    directorNombre:    data.directorNombre || undefined,
    direccion:         data.direccion      || undefined,
    telefono:          data.telefono       || undefined,
    email:             data.email          || undefined,
    turno:             data.turno          || undefined,
  };
}

/** Devuelve la configuración institucional en memoria. */
export function getConfig(): AppConfig {
  return cache;
}

/** Actualiza el caché en memoria (útil tras guardar desde ConfiguracionPage). */
export function patchConfig(overrides: Partial<AppConfig>): void {
  cache = { ...cache, ...overrides };
}

/**
 * @deprecated Stub vacío mantenido por compatibilidad.
 * La carga real la hace institucionService.get() en index.tsx.
 */
export async function cargarConfig(): Promise<AppConfig> {
  return cache;
}
